// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessageEditFormFields-modulebody__vSpL4 ChatroomInputFormFields-modulebody__s42l1";
var _2 = "ChatroomMessageEditFormFields-modulechatroomMessageEditFormFields__W6hbH";
var _3 = "ChatroomMessageEditFormFields-moduleform__odiIb";
var _4 = "ChatroomMessageEditFormFields-moduleformLoading__Cc2JA";
var _5 = "ChatroomMessageEditFormFields-moduleformReady__nI9O9";
export { _1 as "body", _2 as "chatroomMessageEditFormFields", _3 as "form", _4 as "formLoading", _5 as "formReady" }
